// extracted by mini-css-extract-plugin
export default {"Foto":"FotoFilm_Foto__jDY5G","FotoV":"FotoFilm_FotoV__zqMOe","Image":"FotoFilm_Image__b3teB","ImageWrapper":"FotoFilm_ImageWrapper__whtMH"};